/** =========================================================
 * Module: item-control-buttons.directive.js
 * Control item buttons
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemControlButtons', itemControlButtons);

  itemControlButtons.$inject = ['$rootScope'];

  function itemControlButtons($rootScope) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/item-control-buttons.html',
      link: function ($scope) {
        $scope.showEdit = false;
        $scope.showDelete = false;

        function checkEnabled(action) {
          if ($scope.config && $scope.config.model && $scope.config[action]) {
            if (typeof $scope.config[action].permission !== 'undefined') {
              return $scope.config[action].permission;
            }

            return $rootScope.helpers.hasPermissionTo($scope.config.model + ' ' + action);
          }

          return false;
        }

        if ($scope.item !== 'undefined') {
          $scope.showEdit = checkEnabled('edit');
          $scope.showDelete = checkEnabled('delete');
        }

        $scope.$watch('item', function (item) {
          if (typeof item !== 'undefined') {
            $scope.showEdit = checkEnabled('edit');
            $scope.showDelete = checkEnabled('delete');
          }
        });
      },
      scope: {
        config: '=',
        item: '='
      }
    };

    return directive;
  }
})();
